import Loading from '../../../Common/Loading';
import { RegisteredPersonFamilyResponsableRelation } from './RegisteredPersonFamilyResponsableRelation';
import { KnowAboutFather } from './KnowAboutFather';
import { KnowAboutMother } from './KnowAboutMother';
import { useHouseholdRelationshipChartsDataContext } from './hooks/useHouseholdRelationshipChartsDataContext';

export const Charts = () => {
    const { isLoading } = useHouseholdRelationshipChartsDataContext();

    if (isLoading ) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <KnowAboutFather />
                <KnowAboutMother />
            </div>
            <div className="w-100">
                <RegisteredPersonFamilyResponsableRelation />
            </div>
        </>
    );
};
